import PropTypes from 'prop-types';
import { STAT_CARD_BASE, STAT_CHIP } from '../../ui/StatCard';
import { Field, TextArea, TextInput } from './EditorFields';

/**
 * Who is in the room. Names and briefs are editable; teams cannot be added or removed
 * here, because each one owns a deck of options written for it.
 */
const TeamsEditor = ({ functions, kpis, onChange }) => {
  const set = (i, field, value) =>
    onChange(functions.map((f, x) => (x === i ? { ...f, [field]: value } : f)));

  return (
    <div className="space-y-3">
      {functions.map((fn, i) => (
        <div key={fn.key} className={`${STAT_CARD_BASE} space-y-3 p-5`}>
          <div className="flex flex-wrap items-center gap-2">
            <span className={`rounded-md px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${STAT_CHIP[fn.variant] || STAT_CHIP.slate}`}>
              {fn.name || 'Unnamed team'}
            </span>
            {(fn.measuredOn || []).length > 0 && (
              <span className="text-xs text-neutral-400">
                judged on {fn.measuredOn.map((m) => kpis.find((k) => k.key === m)?.label).filter(Boolean).join(' + ')}
              </span>
            )}
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            <Field label="Team name">
              <TextInput value={fn.name} onChange={(v) => set(i, 'name', v)} />
            </Field>
            <Field label="Mandate">
              <TextInput value={fn.mandate} onChange={(v) => set(i, 'mandate', v)} />
            </Field>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            <Field label="Everyone sees">
              <TextArea value={fn.publicBrief} onChange={(v) => set(i, 'publicBrief', v)} rows={3} />
            </Field>
            <Field label="Only this team sees" hint="The pressure that makes them protect their own number.">
              <TextArea value={fn.privateBrief} onChange={(v) => set(i, 'privateBrief', v)} rows={3} />
            </Field>
          </div>
        </div>
      ))}
    </div>
  );
};

TeamsEditor.propTypes = {
  functions: PropTypes.arrayOf(PropTypes.object).isRequired,
  kpis: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TeamsEditor;
